import { withModuleContext } from '@edreamsodigeo/frontend-core';
import { PrismaProvider } from '@edreamsodigeo/prisma-design-system';

const MODULE_NAMESPACE = 'supportArea';
export default withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider,
});
